import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginAdmin } from '@/features/login-admin/page/LoginAdmin';

export const Route = createFileRoute('/admin/auth/login')({
    component: LoginAdmin,
    validateSearch: z.object({ encode: z.string().optional() }),
});
